import { connect } from 'react-redux'
import { Redirect, Route, withRouter } from 'react-router'

import { ADMIN, SUPPORT_ADMIN, SUPPORT } from 'app/constants';

const AuthComponent = withRouter(props => {
  if(!props.isAuthorized) {
    return (<Redirect to="/login" />);
  }

  if(props.onEnter) {
    let redirectPath = props.onEnter(props.auth);
    if(redirectPath) {
      return (<Redirect to={redirectPath} />);
    }
  }

  const { component: Component, match, history, location, auth, path } = props;
  const { user: { role } } = auth;

  if ([SUPPORT].includes(role) && !path.includes('/qr-diagnostics')) {
    return (<Redirect to="/qr-diagnostics" />);
  } else if ([SUPPORT_ADMIN].includes(role) && (!path.includes('/qr-diagnostics') && !path.includes('/users'))) {
    return (<Redirect to="/qr-diagnostics" />);
  }

  return (<Component match={match} history={history} location={location} />);
});

class AuthRoute extends React.Component {
  isAuthorized() {
    let { jwt, user } = this.props.auth;
    if(!jwt || !user) return false;
    if(this.props.admin && ![ADMIN, SUPPORT_ADMIN].includes(user.role)) return false;
    return true;
  }

  render() {
    const { path, exact, auth, component, onEnter } = this.props;

    return (
      <Route path={path} exact={exact}>
        <AuthComponent isAuthorized={this.isAuthorized()} auth={auth} onEnter={onEnter} component={component} path={path} />
      </Route>
    );
  }
}


export default connect(({ auth }) => ({ auth }))(AuthRoute);
